<template>
  <div class="text-to-audio-wrapper">
    <!-- 自定义的textarea -->
    <xes-textarea
      ref="xesTextarea"
      v-model="text"
      rows="4"
      :text="text"
      placeholderText="请输入需要转语音的文字"
      maxCount="350"
      @blurCountCheck="blurCountCheck"
    />
    <!-- 文本规范 -->
    <p class="text-guide">
      <span @click="handleDownload">
        文本输入规范
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </p>
    <!-- 转换筛选项 -->
    <div class="transfer-config">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="发音人">
          <el-select v-model="form.speaker" placeholder="请选择发音人">
            <el-option
              :label="item.label"
              :value="item.id"
              v-for="item in speakerConfig"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="config-list">
          <el-form-item label="音量">
            <el-select v-model="form.volume" placeholder="请选择音量">
              <el-option
                :label="item.label"
                :value="item.id"
                v-for="item in volumeConfig"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="语速">
            <el-select v-model="form.speed" placeholder="请选择语速">
              <el-option
                :label="item.label"
                :value="item.id"
                v-for="item in speedConfig"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="音调">
            <el-select v-model="form.pitch" placeholder="请选择音调">
              <el-option
                :label="item.label"
                :value="item.id"
                v-for="item in pitchConfig"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item class="transfer-btn">
          <el-button type="primary" @click="handleTransfer" :loading="isTransfering">{{buttonText}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 自定义音频 -->
    <xes-audio :audioSrc="audioSrc" />
    <!-- 实例slot -->
    <div class="footer-button">
      <slot name="footer-button" :data="audioSrc"></slot>
    </div>
  </div>
</template>
<script>
import { httpRequest } from '../../../src/utils/ajax'
import { $messageBox } from '../../../src/utils/modus'
import xesAudio from './audio'
import xesTextarea from './xesTextarea'
export default {
  name: 'xes-text-to-audio',
  props: {
    token: {
      type: String,
      required: true
    }
  },
  components: {
    xesAudio,
    xesTextarea
  },
  data () {
    return {
      text: '',
      form: {
        speaker: 'aqiu-chin_normal',
        volume: '5',
        speed: '3',
        pitch: '3'
      },
      speakerConfig: [
        {
          label: '阿丘-语文',
          id: 'aqiu-chin_normal'
        },
        {
          label: '阿丘-数学',
          id: 'aqiu-math_normal'
        },
        {
          label: '小娟老师',
          id: 'xiaojuan_normal'
        }
      ],
      volumeConfig: [
        {
          label: '1',
          id: 1
        },
        {
          label: '2',
          id: 2
        },
        {
          label: '3',
          id: 3
        },
        {
          label: '4',
          id: 4
        },
        {
          label: '5',
          id: 5
        },
        {
          label: '6',
          id: 6
        },
        {
          label: '7',
          id: 7
        },
        {
          label: '8',
          id: 8
        },
        {
          label: '9',
          id: 9
        },
        {
          label: '10',
          id: 10
        }
      ],
      speedConfig: [
        {
          label: '1',
          id: 1
        },
        {
          label: '2',
          id: 2
        },
        {
          label: '3',
          id: 3
        },
        {
          label: '4',
          id: 4
        },
        {
          label: '5',
          id: 5
        }
      ],
      pitchConfig: [
        {
          label: '1',
          id: 1
        },
        {
          label: '2',
          id: 2
        },
        {
          label: '3',
          id: 3
        },
        {
          label: '4',
          id: 4
        },
        {
          label: '5',
          id: 5
        }
      ],
      audioSrc: '',
      audioName: '',
      // audioSrc: 'http://127.0.0.1:5500/Miaow-07-Bubble.mp4',
      isTransfering: false,
      isTransfered: false
    }
  },
  computed: {
    buttonText () {
      if (this.isTransfered && !this.isTransfering) {
        return '重新转换'
      } else if (this.isTransfering) {
        return '转换中'
      } else {
        return '开始转换'
      }
    }
  },
  methods: {
    handleDownload () {
      console.log('下载文件')
      this.downloadWD('http://formula.xesv5.com/xue-frontend-ui/static/aiTransferAudio/specification.docx')
    },
    // 转换
    handleTransfer () {
      if (this.validate()) {
        const params = Object.assign({}, this.form, { text: this.text, token: this.token })
        this.isTransfering = true
        const options = {
          method: 'POST',
          action: 'http://aiweb.xesv5.com/common/wordsConvertVoice',
          params
        }
        httpRequest(options)
          .then(res => {
            if (res.status === 100) {
              this.audioSrc = res.data.voiceUrl
              this.audioName = res.data.voiceName
              $messageBox.point('文本转换成功', 'success')
            } else {
              $messageBox.point(res.data, 'error')
            }
          })
          .catch(err => {
            console.log(err)
            $messageBox.point(err.data, 'error')
          })
          .finally(() => {
            this.isTransfering = false
            this.isTransfered = true
          })
      }
    },
    // 重置参数
    resetData () {
      console.log('重置数据')
      this.form.speaker = 'aqiu-chin_normal'
      this.form.volume = '5'
      this.form.speed = '3'
      this.form.pitch = '3'
      this.text = ''
      this.audioSrc = ''
      this.audioName = ''
      this.$refs.xesTextarea.resetData()
    },
    // 转换前校验相关参数
    validate () {
      if (this.text.trim() === '') {
        const tips = '输入字符不能为空'
        $messageBox.point(tips, 'warning')
        return false
      }
      return true
    },
    // 下载文件方法
    downloadWD (url) {
      fetch(url)
        .then(res => {
          res.blob().then(b => {
            var a = document.createElement("a")
            a.href = URL.createObjectURL(b)
            a.setAttribute("download", 'guide')
            document.body.appendChild(a)
            a.click()
            // 清除
            setTimeout(() => {
              document.body.removeChild(a)
            })
          })
        })
    },
    blurCountCheck () {
      $messageBox.point('最大支持输入350个字符', 'warning')
    }
  }
}
</script>



// WEBPACK FOOTER //
// packages/text-to-audio/src/index.vue